<template>
    <table class="table table-mini-cart">
        <tbody>
            <tr v-for="(item, key) in items.list" :key="key">
                <td class="product-col">
                    <figure class="product-image-container">
                        <a :href="item.url_pro" class="product-image">
                            <picture>
                                <source v-if="$productImageSrcset(item.image_main)" type="image/webp" :srcset="$productImageSrcset(item.image_main)" sizes="80px">
                                <img :src="item.image_main" alt="product">
                            </picture>
                        </a>
                    </figure>
                    <div>
                        <h2 class="product-title">
                            <a :href="item.url_pro">{{ item.pro_name_site }}</a>
                        </h2>

                        <span class="product-qty">Qtd: {{ item.qtd_cart }}</span>
                        <span class="product-qty">Valor Unit: {{ !item.price_to ? currency.money(item.pro_price_site) : currency.money(item.price_to) }}</span>
                    </div>
                </td>
            </tr>
        </tbody>    
    </table>
</template>

<script>
import Currency from '../helpers/parseCurrency'
export default {
    name:'TableMiniCart',
    props: {
        items:{
            required:true
        }
    },
    data() {
        return {
             currency: Currency,
        }
    }
}
</script>